import { ISODate } from '@frk/eds-components';
import { PPSSState, SwitchState } from '@types';

export const INITIAL_STATE: PPSSState = {
  data: {
    tableRows: [],
    filteredTableRows: [],
    asOfDates: {
      navAsOfDate: '',
      performanceAsOfDateMonthly: '',
      performanceAsOfDateMonthlyStd: '' as ISODate,
      performanceAsOfDateQuarterly: '',
      performanceAsOfDateQuarterlyStd: '' as ISODate,
    },
  },
  config: {
    tabs: {
      showPerformance: true,
      showYield: false,
      showRatings: false,
      showFundIdentifiers: false,
    },
    // TODO: some of these may no longer be needed
    performanceViewOptions: [],
    currentTable: 'PERFORMANCE',
    showFavoritesOnlySwitch: false,
    favoriteOnlySwitchState: SwitchState.OFF,
    showDownloadDataButton: false,
    showExchangeRate: false,
  },
  siteConfig: null,
};
